import { QuickReply } from '@connect-x-app/shared-domain-models';

import { IndexableQuickReply } from '../models/indexableQuickReply';

export const mapQuickRepliesToIndexableQuickReplies = (quickReply: QuickReply, index: number): IndexableQuickReply => ({
  ...quickReply,
  index,
});
